<template>
	<div class="declaration-summary">
		<el-form :inline="true" ref="form" :model="form" label-width="80px">
			<!-- <el-form-item label="项目名称">
				<el-select v-model="form.projectId" placeholder="请选择">
					<el-option v-for="item in projectOptions" :key="item.id" :label="item.projectName" :value="item.id"></el-option>
				</el-select>
			</el-form-item> -->
			<el-form-item label="学校">
				<el-select v-model="form.unitId" clearable placeholder="请选择">
					<el-option v-for="item in unitOptions" :key="item.id" :label="item.unitName" :value="item.id"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="单位类型">
				<el-select v-model="form.type" clearable placeholder="请选择">
					<el-option v-for="item in typeOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item><el-button type="primary" @click="search">查询</el-button></el-form-item>
		</el-form>

		<!-- <el-table :data="declarationSumData" border style="width: 100%">
			<el-table-column type="index" label="序号" width="50"></el-table-column>
			<el-table-column prop="unitName" label="学校名称"></el-table-column>
			
		</el-table> -->
		
		<table v-if="declarationSumData.length" id="ktfz-datatable" class="table table-hover table-bordered table-centered table-proApp">
			<thead>
				<tr>
					<th class="text-center">序号</th>
					<th class="text-center">学校名称</th>
					<th class="text-center">单位类型</th>
					<!-- <th class="text-center" v-for="(item, index) in topicTypeNum" :key="index">{{declarationSumData[0]['name'+index]}}</th> -->
					<th class="text-center">合计</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(item, index) in declarationSumData" :key="'a'+index">
					<td class="text-center">{{ index+1 }}</td>
					<td class="text-center">{{ item.unitName }}</td>
					<td class="text-center">{{ item.typeName }}</td>
					<!-- <td class="text-center" v-for="(item1,index1) in topicTypeNum" :key="'b'+index1">{{ item['number'+index1] }}</td> -->
					<td class="text-center">{{ item.totalNumber }}</td>
				</tr>
			</tbody>
		</table>
		<div class="no-data" v-if="declarationSumData.length===0">暂无数据</div>
		

		<div class="btn-wrap"><el-button type="success" @click="exportExcel">导出excel</el-button></div>
	</div>
</template>

<script>
import { getDeclarationSum, getEduProjectLsit } from '@/api/after/projectApplication.js';
import { getUnitList,getPlatformInformationData } from '@/api/after/systemManagement.js';
import FileSaver from "file-saver";
	import XLSX from "xlsx";
export default {
	data() {
		return {
			form: {
				projectId: '',
				type: '', //学段
				unitId: ''
			},
			projectOptions: [],
			projectData:{},
			unitOptions: [],
			typeOptions: [],//单位类型选项
			declarationSumData: [],
			topicTypeNum:0,//课题类型数量
		};
	},
	async created() {
		// await this.getEduProjectLsit()
		let projectData=sessionStorage.getItem('projectData')
		if(projectData){
			this.projectData=JSON.parse(projectData)
			this.form.projectId = this.projectData.id;
		}else{
			this.$message({
				type:'error',
				message:'没有项目！',
				onClose:()=>{
					this.$router.go(-1)
				}
			})
		}
		this.getDeclarationSum()
		this.getUnitList()
		this.getUnitType()
	},
	methods: {
		search(){
			this.getDeclarationSum()
		},
		// 导出Excel列表
		exportExcel(){
			var xlsxParam = { raw: true };
			var wb = XLSX.utils.table_to_book(
			  document.querySelector("#ktfz-datatable"),
			  xlsxParam
			);
			var wbout = XLSX.write(wb, {
			  bookType: "xlsx",
			  bookSST: true,
			  type: "array",
			});
			try {
			  FileSaver.saveAs(
			    new Blob([wbout], { type: "application/octet-stream" }),
			    "申报汇总.xlsx"
			  );
			} catch (e) {
			  if (typeof console !== "undefined") {
			    console.log(e, wbout);
			  }
			}
			return wbout;
		},
		// 获取单位类型
		async getUnitType(){
			const res = await getPlatformInformationData(9)
			if (res.code == 200) {
				this.typeOptions = res.data
			}else{
				this.$message.error(res.data)
			}
		},
		// 获取单位列表
		async getUnitList() {
			let params = {
				id: 0,
				name: '',
				pageNumber: 1,
				pageSize: 999,
				pageSorts: [
					{
						asc: true,
						column: ''
					}
				]
			};
			const res = await getUnitList(params);
			if (res.code==200) {
				this.unitOptions = res.data.records
			}
		},
		// 获取项目列表
		async getEduProjectLsit() {
			const res = await getEduProjectLsit();
			if (res.code == 200) {
				this.projectOptions = res.data
			}
		},
		// 获取申报汇总数据
		async getDeclarationSum() {
			const res = await getDeclarationSum(this.form);
			if (res.code == 200) {
				this.declarationSumData = res.data;
				if (res.data.length>0) {
					this.topicTypeNum = res.data.[0].size
				}
			}
		}
	}
};
</script>

<style scoped lang="scss">
.btn-wrap {
	margin-top: 20px;
}
.no-data{
	width: 100%;
	height: 50px;
	text-align: center;
	line-height: 50px;
}
</style>
